import { render, staticRenderFns } from "./PaymentConfigEditor.vue?vue&type=template&id=71b84061&scoped=true&"
import script from "./PaymentConfigEditor.vue?vue&type=script&lang=js&"
export * from "./PaymentConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfigEditor.vue?vue&type=style&index=0&id=71b84061&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b84061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VTab,VTabs,VToolbar})
